import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (this.classList.contains('text-block--normalized')) {
      this.#removeEmptyParagraphs();
    }
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Removes spacing-only paragraphs from text blocks.
   */
  #removeEmptyParagraphs() {
    this.querySelectorAll('p').forEach((paragraph) => {
      const text = paragraph.textContent?.replace(/\u00a0/g, '').trim();
      const hasContentElement = paragraph.querySelector('img, video, iframe, table, svg');

      if (text === '' && !hasContentElement) {
        paragraph.remove();
      }
    });
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
